import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Input class={{concat \"input l-fill input-phone \" this._isInvalid this.inputClassNames}} placeholder={{this.placeholder}} disabled={{this.disabled}} @type=\"tel\" />", {
  moduleName: "@dashboard/shared-ui/components/sq-input-phone.hbs"
});